/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreBank131DisableRecurrentPaymentResponse interface.
 */
export function instanceOfFxIdApplicationStoreBank131DisableRecurrentPaymentResponse(value) {
    if (!('Success' in value) || value['Success'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreBank131DisableRecurrentPaymentResponseFromJSON(json) {
    return FxIdApplicationStoreBank131DisableRecurrentPaymentResponseFromJSONTyped(json, false);
}
export function FxIdApplicationStoreBank131DisableRecurrentPaymentResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Success': json['Success'],
    };
}
export function FxIdApplicationStoreBank131DisableRecurrentPaymentResponseToJSON(json) {
    return FxIdApplicationStoreBank131DisableRecurrentPaymentResponseToJSONTyped(json, false);
}
export function FxIdApplicationStoreBank131DisableRecurrentPaymentResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Success': value['Success'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreBank131DisableRecurrentPaymentResponse.js.map